function wsConnect() {
    return {
        type: 'WS_CONNECT',
    };
}

function created() {
    return {
        type: 'WS_CREATED',
    };
}

function closed() {
    return {
        type: 'WS_CLOSED',
    };
}

function error() {
    return {
        type: 'WS_ERROR',
    };
}

function connectionCreated() {
    return (dispatch) => {
        dispatch(created());
        // dispatch(chatActions.enableUI());
    };
}


function connectionClosed() {
    return (dispatch) => {
        dispatch(closed());
        // dispatch(chatActions.disableUI());
    };
}

function connectionError() {
    return (dispatch) => {
        dispatch(error());
        console.log('ERROR')
        // dispatch(chatActions.disableUI());
    };
}

export {
    wsConnect,
    created,
    closed,
    error,
    connectionCreated,
    connectionClosed,
    connectionError
};


// WEBPACK FOOTER //
// ./src/lib/redux/actions/socket.js